<template>
  <div v-if="dialogshow">
    <el-dialog
      id="dialogReader"
      class="KNS-dialog"
      :visible.sync="dialogshow"
      :close-on-click-modal="closeOnClickModal"
      width="900px"
      center
    >
      <div :class="[type == 'postal'? 'postal':'','detail-wrap']">
        <el-button
          v-if="model == 'basic' && type == 'postal'"
          size="mini"
          class="btn"
          @click="yourselfEnter=true"
        >
          自行輸入條碼
        </el-button>
        <div :class="[type,'diagram']" />
        <div class="tabletinfo">
          <h2 v-if="model == 'basic' && type == 'NFC' && customizeMessage.title == ''">
            請感應門禁卡...
          </h2>
          <h2 v-if="model == 'basic' && type == 'Barcode' && customizeMessage.title == ''">
            請住戶開啟APP，掃描住戶手機條碼
          </h2>
          <h2 v-if="model == 'basic' && type == 'postal' && customizeMessage.title == ''">
            請掃描包裹/郵件條碼...
          </h2>
          <!--//自訂訊息 -->
          <h2 v-if="model == 'basic' && customizeMessage.title != ''">
            {{ customizeMessage.title }}
          </h2>
          <h4 v-if="model == 'basic' && customizeMessage.subtitle != ''">
            {{ customizeMessage.subtitle }}
          </h4>
        </div>
        <!-- 住戶開通-NFC -->
        <div
          v-if="model == 'active' && type == 'NFC'"
          class="tabletinfo"
        >
          <p class="tabletCheck">
            請確認開通戶別 : {{ tabletInfo.tablet_note }}
          </p>
          <h2>請住戶將載具放在感應區</h2>
          <h4>門禁卡、磁扣、悠遊卡、一卡通等</h4>
        </div>
        <!-- 住戶開通-Barcode -->
        <div
          v-if="model == 'active' && type == 'Barcode'"
          class="tabletinfo"
        >
          <p class="tabletCheck">
            請確認開通戶別 : {{ tabletInfo.tablet_note }}
          </p>
          <h2>請住戶開啟APP，掃描住戶手機條碼</h2>
        </div>
        <div
          v-if="sandData"
          class="authentic"
        >
          <span v-if="type == 'NFC'">卡片/磁扣驗證中...</span>
          <span v-if="type == 'Barcode'">條碼驗證中...</span>
          <span v-if="type == 'postal'">包裹條碼驗證中...</span>
        </div>
        <input
          v-if="!yourselfEnter"
          id="input_code"
          ref="input"
          v-model="code"
          type="password"
          autocomplete="new-password"
          :disabled="sandData"
          @keyup.enter="sandCode"
          @keyup.esc="sandCodeBatchOpen"
          @blur="onblur"
          @keyup="keyup"
        >
      </div>
      <span
        v-if="model == 'active'"
        slot="footer"
      >
        <el-checkbox
          v-model="batchOpen"
          class="checkbox"
        />
        <span>打勾可進行同戶一次多項裝置開通，完成開通最後請按 ESC鍵 或</span>
        <el-button
          size="mini"
          class="btn"
          @click="sandCodeBatchOpen"
        >點此確認開通</el-button>
      </span>
    </el-dialog>

    <el-dialog
      id="yourselfEnter"
      class="KNS-dialog"
      title="請輸入包裹/郵件條碼"
      :visible.sync="yourselfEnter"
      width="900px"
      center
    >
      <div class="detail-wrap">
        <div class="fakeInputWrap">
          <input
            id="input_code_yourself"
            ref="inputYourself"
            v-model="code"
            type="text"
            placeholder="請輸入條碼"
            @blur="onblur"
          >
          <el-popover
            v-model="showCopyMSg"
            placement="left-start"
            :content="copyMSg"
            popper-class="dark"
          >
            <el-button
              slot="reference"
              size="mini"
              class="btn"
              @click="copyBarcode"
            >
              複製條碼
            </el-button>
          </el-popover>
        </div>
        <div class="footer">
          <el-button
            type="primary"
            class="btn"
            @click="sandCode"
          >
            確認
          </el-button>
        </div>
      </div>
    </el-dialog>
    <repeatedOpeningDialog ref="repeatedDialog" />
  </div>
</template>

<script>
import RepeatedOpeningDialog from '@/components/RepeatedOpeningDialog'
import { setTimeout } from 'timers'
export default {
  components: {
    repeatedOpeningDialog: RepeatedOpeningDialog
  },
  props: {
    closeOnClickModal: true,
    manualInput: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      type: '', // NFC & Barcode & postal
      model: 'basic', // basic & active(戶別開通)
      dialogshow: false, // 開關,
      yourselfEnter: false, // 自行輸入條碼
      callBackFunc: null, // 回吊函式
      sandData: false, // loading狀態
      code: '',
      codeList: [],
      tabletInfo: Object, // 住戶資訊
      batchOpen: false, // 是否批次,
      copyMSg: '',
      showCopyMSg: false,
      customizeMessage: {
        title: '',
        subtitle: ''
      },
      iskeyupStarted: false,
      canSandCode: true,
      manualInputTimeout: null
    }
  },
  watch: {
    sandData () {
      setTimeout(() => {
        try {
          document.getElementById('input_code').focus()
        } catch (error) {
        }
      }, 1)
    },
    yourselfEnter (now_val) {
      if (now_val) {
        setTimeout(() => document.getElementById('input_code_yourself').focus(), 500)
        this.code = ''
      }
    }
  },
  methods: {
    getCode (cbfunc, option) {
      this.batchOpen = false
      this.callBackFunc = cbfunc
      this.code = ''
      this.codeList = []
      if (typeof (option) === 'string') {
        this.type = option
      } else if (typeof (option) === 'object') {
        this.type = option.type
        this.model = option.model
        this.tabletInfo = option.tabletInfo
        this.customizeMessage.title = option.title
        this.customizeMessage.subtitle = option.subtitle
      }
      this.dialogshow = true
      this.$nextTick(() => {
        document.getElementById('input_code').focus()
      })
    },
    keyup (e) {
      const vm = this
      if (!this.manualInput && !vm.iskeyupStarted && e.keyCode !== 13) {
        vm.iskeyupStarted = true
        vm.manualInputTimeout = window.setTimeout(() => {
          vm.canSandCode = false
        }, 1000)
      }
    },
    sandCode (eve) {
      const vobj = this
      // eslint-disable-next-line eqeqeq
      if (this.sandData || this.code == '') {
        return false
      }
      window.clearTimeout(this.manualInputTimeout)
      if (!this.manualInput && !this.canSandCode) {
        this.sandData = true
        this.$alert('感應失敗，請再次感應卡片', '警告', {
          confirmButtonText: '確認',
          type: 'warning',
          showClose: false,
          roundButton: true,
          closeOnClickModal: false,
          callback: action => {
            this.iskeyupStarted = false
            this.canSandCode = true
            this.sandData = false
            this.code = ''
          }
        })
        return false
      }
      // eslint-disable-next-line eqeqeq
      if (this.type == 'Barcode' && this.code.length != 16) {
        vobj.code = ''
        vobj.sandData = false
        this.$alert('條碼長度不符！', '', {
          confirmButtonText: '確定',
          callback: action => {

          }
        })
        return false
      }
      // eslint-disable-next-line eqeqeq
      if (this.model == 'basic') { // 一般模式
        this.sandData = true
        this.callBackFunc(this.code)
        this.yourselfEnter = false
      // eslint-disable-next-line eqeqeq
      } else if (this.model == 'active') { // 開通模式
        // NFC掃描
        this.sandData = true
        // eslint-disable-next-line eqeqeq
        if (this.type == 'NFC') {
          // 檢查是否重複開通
          this.checkNFCRepeatOpen(this.code).then((res) => {
            // eslint-disable-next-line eqeqeq
            if (res.data.list == 'error_noData') { // 無重複開通
              nextStep()
            } else { // 有重複開通
              this.$refs.repeatedDialog.alert(res.data, callback => {
                if (callback) {
                  nextStep()
                } else {
                  vobj.code = ''
                  vobj.sandData = false
                  if (!this.batchOpen) this.close()
                }
              })
            }
          })
        }
        // Barcode掃描
        // eslint-disable-next-line eqeqeq
        if (this.type == 'Barcode') {
          nextStep()
        }
        function nextStep () {
          if (vobj.batchOpen) { // 批次開通
            vobj.codeList.push(vobj.code)
            vobj.code = ''
            vobj.sandData = false
            vobj.$notify({
              title: '批次開通',
              message: `目前批次開通數量：${vobj.codeList.length}`,
              position: 'bottom-right',
              type: 'success'
            })
          } else { // 無批次開通
            vobj.callBackFunc(vobj.code)
          }
        }
      }
    },
    sandCodeBatchOpen () {
      if (!this.batchOpen) {
        return false
      }
      // eslint-disable-next-line eqeqeq
      if (this.codeList.length == 0) {
        this.close()
        return false
      }
      this.sandData = true
      this.callBackFunc(this.codeList)
    },
    onblur () {
      try {
        if (!this.yourselfEnter) {
          document.getElementById('input_code').focus()
        } else {
          document.getElementById('input_code_yourself').focus()
        }
      } catch (error) {
      }
    },
    close () {
      this.type = ''
      this.model = 'basic'
      this.dialogshow = false
      this.callBackFunc = null
      this.sandData = false
      this.code = ''
      this.codeList = []
      this.tabletInfo = Object
      this.batchOpen = false
    },
    resetInput () {
      this.sandData = false
      this.iskeyupStarted = false
      this.canSandCode = true
      this.code = ''
    },
    checkNFCRepeatOpen (code) {
      return new Promise((resolve, reject) => {
        const url = process.env.NODE_ENV === 'development' ? '/house/getCarrierInfo' : `${process.env.VUE_APP_WS_URL}/getCarrierInfo`
        const formdata = new FormData()
        formdata.append('code', code)
        axios(url, {
          method: 'POST',
          data: formdata,
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'cache-control': 'no-cache'
          }
        }).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    copyBarcode () {
      // eslint-disable-next-line eqeqeq
      if (this.code == '') {
        this.copyMSg = '未輸入條碼 !'
      } else {
        const selectObj = document.getElementById('input_code_yourself')
        const selection = window.getSelection()
        const range = document.createRange()
        range.selectNode(selectObj)
        selection.removeAllRanges()
        selection.addRange(range)
        document.execCommand('copy')
        this.copyMSg = '複製成功 !'
      }
      this.showCopyMSg = true
      setTimeout(() => { this.showCopyMSg = false }, 3000)
    }
  }
}
</script>

<style lang="sass" scoped>
  #yourselfEnter
    ::v-deep .el-dialog__header
      padding-bottom: 10px
      background: #cecece
      color: #333333
      font-size: 16px
      text-align: left
      padding: 15px 15px 10px 15px
      .el-dialog__title
        font-size: 20px
        font-weight: bold
        color: #5f5f5f
    ::v-deep .el-dialog__body
      padding: 0
      .detail-wrap
        padding: 20px
      .fakeInputWrap
        margin: 70px 30px 10px 30px
        input
          font-size: 50px
          height: 80px
          text-align: center
          z-index: -1
          width: 100%
          padding: 3px 12px
          color: #000
          background-color: #fff
          background-image: none
          border: 1px solid #ccc
          box-sizing: border-box
        button
          margin-top: 20px
          float: right
      .footer
        margin-top: 70px
        text-align: center
  #dialogReader
    ::v-deep .el-dialog__footer
      padding: 15px
      color: #999
      border-top: 1px solid #e5e5e5
      text-align: center
      .checkbox
        margin-right: 2px
      .btn
        margin-left: 5px
    ::v-deep .el-dialog__header
      background: #fff
    ::v-deep .el-dialog__body
    .detail-wrap
      position: relative
      &.postal
        padding-top: 0
      .diagram
        display: block
        width: 200px
        height: 200px
        background-size: contain
        border-radius: 0
        border: none
        background-position: center center
        background-repeat: no-repeat
        margin: 0 auto
        margin-top: 25px
        &.NFC
          background-image: url('../assets/img/NFC/nfg_card.gif')
        &.Barcode
          background-image: url('../assets/img/Barcode/barcode-g.gif')
        &.postal
          background-image: url('../assets/img/postal/package-scan.gif')
      h2
        text-align: center
        font-weight: bold
        font-size: 30px
        margin: 20px 0 10px 0
        color: #2f2f2f
      .authentic
        position: absolute
        // bottom: -25px
        left: 0
        width: 100%
        text-align: center
        background-color: #fcf8e3
        span
          font-size: 22px
          color: #8a6d3b
          line-height: normal
          padding: 3px 0
          display: block
      input
        border: hidden
        color: #fff
        width: 1px
        opacity: 0
      .tabletinfo
        .tabletCheck
          text-align: center
          font-weight: bold
          font-size: 28px
          margin: 20px 0 0
          color: #2f2f2f
        h4
          text-align: center
          color: #4b4b4b
          font-size: 18px
          font-weight: 500

</style>
